import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import moment from "moment";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getparticipantHistory,
  sendParticipantChat,
} from "store/registrationdmin-history/actions";
import { isEmpty } from "lodash";
import "assets/scss/table.scss";

class LabHistory extends Component {
  constructor(props) {
    super(props);
    this.chatEndRef = React.createRef();
    this.state = {
      participantHistory: [],
      message: "",
      participantChat: [],
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };
  }

  componentDidMount() {
    const { ongetActivityLogCsr } = this.props;
    const routeId = this.props.match?.params?.id;
    const id = routeId || this.state.user_id;

    if (id) {
      this.setState({ participantHistory: [] });
      ongetActivityLogCsr(id);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.participantHistory !== this.props.participantHistory ||
      prevProps.participantChatMessages !==
        this.props.participantChatMessages ||
      prevProps.paymentChatMessages !== this.props.paymentChatMessages
    ) {
      const unifiedLogs = [];

      this.props.participantHistory?.forEach(log => {
        // Lab registrations
        log.lab_registration_history?.forEach(lab => {
          if (!lab?.registration_date) return;
          unifiedLogs.push({
            type: "lab_registration",
            timestamp: lab.registration_date,
            data: lab,
          });

          // Always push approval status — Approved or Pending
          unifiedLogs.push({
            type: "approval",
            timestamp: lab.approved_at || lab.registration_date,
            data: lab,
          });
        });

        // Payments
        log.payment_history?.forEach(payment => {
          const paymentTimestamp = payment.date || payment.reconciled_at;
          if (paymentTimestamp) {
            unifiedLogs.push({
              type: "payment",
              timestamp: paymentTimestamp,
              data: { ...payment, lab_name: log.lab_name },
            });
          }

          if (payment?.reconciled_at) {
            unifiedLogs.push({
              type: "payment_reconciled",
              timestamp: payment.reconciled_at,
              data: payment,
            });
          }

          const paymentChats =
            this.props.paymentChatMessages?.filter(
              chat => chat.payment_id === payment.payment_id
            ) || [];

          paymentChats.forEach(chat => {
            if (!chat?.timestamp) return;
            unifiedLogs.push({
              type: "payment_chat",
              timestamp: chat.timestamp,
              data: chat,
            });
          });
        });

        // Membership History
        log.membership_history?.forEach(member => {
          if (!member?.timestamp) return;
          unifiedLogs.push({
            type: "membership",
            timestamp: member.timestamp,
            data: { ...member, lab_name: log.lab_name },
          });
        });

        // ---------------- Activity / Lab Update Logs ----------------
        log.logs?.forEach(activity => {
          if (!activity.timestamp) return;
          unifiedLogs.push({
            type: "activity_log",
            timestamp: activity.timestamp,
            data: activity,
          });
        });
      });

      // Participant Chats
      this.props.participantChatMessages?.forEach(chat => {
        if (!chat?.timestamp) return;
        unifiedLogs.push({
          type: "participant_chat",
          timestamp: chat.timestamp,
          data: {
            ...chat,
            username: chat.username || chat.participant_name || "Unknown",
          },
        });
      });

      // Sort by timestamp
      unifiedLogs.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

      this.setState({ participantChat: unifiedLogs }, this.scrollToBottom);
    }
  }

  scrollToBottom = () => {
    if (this.chatEndRef.current) {
      this.chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  handleSend = () => {
    const { message, user_id, participantChat } = this.state;
    const participant_id = this.props.match?.params?.id;
    const participant_name = this.props.match?.params?.name || "Unknown";

    if (!message.trim()) return;

    const timestamp = new Date().toISOString();

    // Optimistic UI update
    this.setState({
      participantChat: [
        ...participantChat,
        {
          type: "participant_chat",
          timestamp,
          data: {
            participant_id,
            participant_name,
            message,
            user_id,
            username: participant_name,
          },
        },
      ],
      message: "",
    });

    // Send payload to backend
    const payload = { user_id, participant_id, message, timestamp };
    this.props.onSendChatMessage(payload);

    // Auto refresh after save
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  formatSchemeCycle = (scheme, cycle) => {
    if (!scheme || !cycle) return "-";

    const schemes = scheme.toString().split(",");
    const cycles = cycle.toString().split(",");

    return schemes
      .map((s, index) => {
        return `${s.trim()} : Cycle ${cycles[index]?.trim() || "-"}`;
      })
      .join(", ");
  };
  render() {
    const { participantChat, message } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>History | Rounds</title>
          </MetaTags>

          <Container fluid>
            <Row className="mb-3">
              <Col lg="8">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.props.history.goBack()}
                >
                  Back
                </button>
              </Col>
            </Row>
            <Breadcrumbs title="History" breadcrumbItem="Activity Log" />

            <Row>
              <Col lg="8" className="offset-lg-2">
                <Card className="mb-2">
                  <CardBody>
                    {participantChat.length > 0 ? (
                      participantChat.map((item, index) => {
                        // Determine background color class based on type
                        let bgClass = "bg-light"; // default
                        if (item.type === "payment")
                          bgClass = "bg-success bg-opacity-10";
                        else if (item.type === "payment_chat")
                          bgClass = "bg-info bg-opacity-10";
                        else if (item.type === "participant_chat")
                          bgClass = "bg-warning bg-opacity-10";
                        else if (item.type === "lab_registration")
                          bgClass = "bg-secondary bg-opacity-10";
                        else if (item.type === "approval")
                          bgClass = item.data.is_approved
                            ? "bg-success bg-opacity-25"
                            : "bg-warning bg-opacity-10";
                        return (
                          <div
                            key={index}
                            className={`p-2 mb-2 border rounded ${bgClass}`}
                          >
                            {/* Date */}
                            <small className="text-muted d-block mb-1">
                              {moment(item.timestamp).format(
                                "DD-MMM-YY, h:mm A"
                              )}
                            </small>

                            {/* Lab Registration */}
                            {item.type === "lab_registration" &&
                              item.data.registration_date && (
                                <div>
                                  <span className="fw-bold text-dark">
                                    {item.data.added_by_staff_name || "Unknown"}
                                  </span>{" "}
                                  registered lab <b>{item.data.name}</b> –{" "}
                                  {item.data.city}, {item.data.province}
                                </div>
                              )}
                            {item.type === "approval" && (
                              <div>
                                Lab <b>{item.data.name}</b> is{" "}
                                {item.data.is_approved ? (
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Approved
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      color: "orange",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Pending for Approval
                                  </span>
                                )}
                              </div>
                            )}
                            {/* Participant Chat */}
                            {item.type === "participant_chat" &&
                              item.data.message && (
                                <div>
                                  <span className="fw-bold text-dark">
                                    {item.data.username}
                                  </span>{" "}
                                  added the message: {item.data.message}
                                </div>
                              )}

                            {/* Payment */}
                            {/* Payment */}
                            {item.type === "payment" && (
                              <div>
                                {/* Payment ID */}
                                <div className="fw-bold text-dark mb-1">
                                  Payment ID: {item.data.payment_id}
                                </div>

                                {/* Entry Date */}
                                <div className="mb-1">
                                  <span className="fw-bold">Entry Date: </span>
                                  {item.data.date
                                    ? moment(item.data.date).format(
                                        "DD-MMM-YY, h:mm A"
                                      )
                                    : "-"}
                                </div>

                                {/* Payment Date */}
                                <div className="mb-1">
                                  <span className="fw-bold">
                                    Payment Date:{" "}
                                  </span>
                                  {item.data.paydate
                                    ? moment(item.data.paydate).format(
                                        "DD-MMM-YY"
                                      )
                                    : "-"}
                                </div>

                                {/* Scheme + Cycle */}
                                <div className="mb-1">
                                  {this.formatSchemeCycle(
                                    item.data.scheme,
                                    item.data.cycle
                                  )}
                                </div>

                                {/* Payment Details */}
                                <div>
                                  <span className="fw-bold text-dark">
                                    {item.data.entered_by || "Unknown"}
                                  </span>{" "}
                                  entered payment of{" "}
                                  <b>
                                    {Number(
                                      item.data.amount || 0
                                    ).toLocaleString()}
                                  </b>{" "}
                                  for lab <b>{item.data.lab_name || "-"}</b>
                                </div>

                                <div>
                                  <span className="fw-bold">Status: </span>
                                  <i>
                                    {item.data.status_detail ||
                                      item.data.status}
                                  </i>
                                </div>
                              </div>
                            )}

                            {item.type === "payment_reconciled" && (
                              <div>
                                <span className="fw-bold text-dark">
                                  {item.data.reconciled_by || "Unknown"}
                                </span>{" "}
                                reconciled payment of{" "}
                                <b>
                                  {Number(
                                    item.data.amount || 0
                                  ).toLocaleString()}
                                </b>
                              </div>
                            )}
                            {/* Payment Chat */}
                            {item.type === "payment_chat" && item.data.message && (
                              <div>
                                <span className="fw-bold text-dark">
                                  {item.data.username}
                                </span>{" "}
                                added the message: {item.data.message}
                              </div>
                            )}
                            {/* Membership History */}
                            {item.type === "membership" &&
                              item.data.membership_status && (
                                <div>
                                  <span className="fw-bold text-dark">
                                    {item.data.changed_by_username || "Unknown"}
                                  </span>{" "}
                                  <span
                                    style={{
                                      color:
                                        item.data.membership_status ===
                                        "Deleted"
                                          ? "red"
                                          : item.data.membership_status ===
                                              "Active" ||
                                            item.data.membership_status ===
                                              "Reactivated"
                                          ? "green"
                                          : "black",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {item.data.membership_status === "Deleted"
                                      ? "Membership Deleted"
                                      : item.data.membership_status ===
                                          "Active" ||
                                        item.data.membership_status ===
                                          "Reactivated"
                                      ? "Membership Reactivated"
                                      : item.data.membership_status}
                                  </span>{" "}
                                  {item.data.lab_name
                                    ? `for Lab ${item.data.lab_name}`
                                    : ""}
                                  {item.data.comments
                                    ? ` - ${item.data.comments}`
                                    : ""}
                                </div>
                              )}

                            {/* Activity Logs */}
                            {item.type === "activity_log" &&
                              item.data.comments && (
                                <div>
                                  <span className="fw-bold text-dark">
                                    {item.data.added_by || "Unknown"}
                                  </span>{" "}
                                  changed:
                                  <div
                                    style={{
                                      marginTop: "5px",
                                      paddingLeft: "15px",
                                    }}
                                  >
                                    {item.data.comments
                                      .split("\n")
                                      .map((line, idx) => (
                                        <div key={idx}>{line}</div>
                                      ))}
                                  </div>
                                </div>
                              )}
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center text-muted">
                        No history found
                      </div>
                    )}
                    <div ref={this.chatEndRef} />
                  </CardBody>
                </Card>

                {/* Message input */}
                <Card className="mb-2">
                  <CardBody>
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Type a message..."
                        value={message}
                        onChange={e =>
                          this.setState({ message: e.target.value })
                        }
                        onKeyPress={e => e.key === "Enter" && this.handleSend()}
                      />
                      <button
                        className="btn btn-primary ml-2"
                        onClick={this.handleSend}
                      >
                        Send
                      </button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

LabHistory.propTypes = {
  match: PropTypes.object,
  participantHistory: PropTypes.array,
  ongetActivityLogCsr: PropTypes.func,
  onSendChatMessage: PropTypes.func.isRequired,
  paymentChatMessages: PropTypes.array,
  participantChatMessages: PropTypes.array,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  participantHistory: state.activitylogRounds.participantHistory,
  paymentChatMessages: state.activitylogRounds.paymentChatMessages,
  participantChatMessages: state.activitylogRounds.participantChatMessages,
});

const mapDispatchToProps = dispatch => ({
  ongetActivityLogCsr: id => dispatch(getparticipantHistory(id)),
  onSendChatMessage: data => dispatch(sendParticipantChat(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LabHistory));
